// extracted by mini-css-extract-plugin
export default {"mobileContainer":"VendorPopup-mobile_mobileContainer__xGe1u","tabSelectBox":"VendorPopup-mobile_tabSelectBox__uAhaH"};